<div class="alarm_screen" style="box-shadow: 1px 3px 1px #80808024">
  <div class="alarm_container">
    <div class="alarm_header">
      <h4 style="text-transform: capitalize">
        {{ action == "update" ? "update" : "add" }} Discount
      </h4>
    </div>
    <div class="alarm_body">
      <div *ngIf="action !== 'update'">
        <div class="row">
          <div class="flex-between p-0">
            <label>Linked Account List</label>
            <div class="flex-start filters">
              <div class="flex-start">
                <input
                  type="checkbox"
                  id="select_all_accounts"
                  (change)="selectAllchilds($event)"
                />
                <label for="select_all_accounts">Select All</label>
              </div>
            </div>
          </div>

          <select
            class="form-control"
            id="linkedAccounts"
            [(ngModel)]="childs"
            (change)="onAccountChange($event)"
            data-live-search="true"
            multiple
            required
          >
            <option
              *ngFor="let master of linkedAccounts['list']"
              [value]="master.accountId"
            >
              {{ master.accountId }} ({{ master.accountName }})
            </option>
          </select>
        </div>
      </div>

      <div class="form-group mb-3" *ngIf="action !== 'update'">
        <label>Select Type</label>

        <div style="display: flex; gap: 20px; align-items: center">
          <label>
            <input
              type="radio"
              name="type"
              value="cfrc"
              [(ngModel)]="mrrDatasub.type"
            />
            CFRC
          </label>

          <label>
            <input
              type="radio"
              name="type"
              value="mrr"
              [(ngModel)]="mrrDatasub.type"
            />
            MRR
          </label>

          <label>
            <input
              type="radio"
              name="type"
              value="s3"
              [(ngModel)]="mrrDatasub.type"
            />
            S3
          </label>

          <label>
            <input
              type="radio"
              name="type"
              value="ec2"
              [(ngModel)]="mrrDatasub.type"
            />
            EC2
          </label>

          <label>
            <input
              type="radio"
              name="type"
              value="rds-ri"
              [(ngModel)]="mrrDatasub.type"
            />
            RDS RI
          </label>
        </div>
      </div>

      <!-- Pass required inputs to child component -->
      <new-mrr-update
        *ngIf="mrrDatasub?.type === 'mrr' || activeTabId === 'mrr'"
        [action]="action"
        [mrr]="mrr"
        [mrrDatasub]="mrrDatasub"
        [unsaved]="unsaved"
        [mrrData]="mrrData"
        [mid]="mid"
        [childs]="childs"
        (hideModel)="close()"
      >
      </new-mrr-update>
      <mrr-enables3-update
        *ngIf="mrrDatasub?.type === 's3' || activeTabId === 's3'"
        [ri]="data"
        [action]="action"
        [childs]="childs"
      >
      </mrr-enables3-update>

      <mrr-enablecfrc-update
        *ngIf="mrrDatasub?.type === 'cfrc' || activeTabId === 'cfrc'"
        [ri]="data"
        [action]="action"
        [childs]="childs"
      >
      </mrr-enablecfrc-update>
      <mrr-enableri-update
        *ngIf="mrrDatasub?.type === 'ec2' || activeTabId === 'ec2'"
        [ri]="data"
        [action]="action"
      >
      </mrr-enableri-update>
    </div>

    <div class="alarm_actions">
      <div style="display: flex; justify-content: flex-end">
        <button
          class="btn"
          (click)="openOtpPopup()"
          style="
            background-color: #5864ff;
            color: white;
            text-transform: capitalize;
            margin-right: 20px;
          "
        >
          {{ action == "add" ? "add" : action }}
        </button>

        <button class="btn btn-light" (click)="close()">Cancel</button>
      </div>
    </div>
  </div>

  <!-- Modal Template for Service Status -->
  <div *ngIf="isModalVisible" class="modal-overlay">
    <div class="modal-content">
      <div *ngFor="let service of childs" class="service-status">
        <span>{{ service.name }}</span>
        <div class="status-icon">
          <div *ngIf="service?.isLoading" class="circle loading">
            <span class="icon">⟳</span>
          </div>
          <div *ngIf="service?.isSuccess" class="circle success">
            <span class="icon">✔</span>
          </div>
          <div *ngIf="service?.isError" class="circle error">
            <span class="icon">✘</span>
          </div>
        </div>
      </div>
      <button [disabled]="!allCallsCompleted" (click)="closeModal()">
        Close
      </button>
    </div>
  </div>

  <!-- OTP Modal -->
  <div class="otp-modal" *ngIf="showOtpModal">
    <div class="otp-box">
      <h4>Enter OTP</h4>

      <input
        type="text"
        [(ngModel)]="enteredOtp"
        maxlength="6"
        placeholder="Enter 6 digit OTP"
        class="form-control"
      />

      <div class="otp-actions">
        <button class="btn btn-primary" (click)="verifyOtp()">Verify</button>
        <button class="btn btn-light" (click)="closeOtp()">Cancel</button>
      </div>

      <p class="error" *ngIf="otpError">{{ otpError }}</p>
    </div>
  </div>

  <style>
    /* Fixed height container with flexbox layout */
    .alarm_screen {
      display: flex;
      flex-direction: column;
      max-width: 100vw;
      max-height: 700px;
    }

    .alarm_container {
      width: 80%;
      display: flex;
      flex-direction: column;
      height: 100%;
      border-radius: 8px;
      background: white;
    }

    /* Header - fixed size, doesn't scroll */
    .alarm_header {
      flex-shrink: 0;
      padding: 15px 25px;
      border-bottom: 1px solid #e0e0e0;
    }

    .alarm_header h4 {
      margin: 0;
    }

    /* Body - scrollable content area */
    .alarm_body {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 15px 25px;
      min-height: 0;
    }

    /* Footer - fixed size, doesn't scroll */
    .alarm_actions {
      flex-shrink: 0;
      padding: 15px 25px;
      border-top: 1px solid #e0e0e0;
    }

    .otp-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1001;
    }

    .otp-box {
      background: white;
      padding: 20px;
      border-radius: 8px;
      width: 300px;
    }

    .otp-actions {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
    }

    .error {
      color: red;
      margin-top: 10px;
    }

    .alarm_screen label {
      padding: 0 !important;
    }

    /* Modal Overlay to cover entire screen */
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    }

    /* Modal Content Box */
    .modal-content {
      background: white;
      padding: 20px;
      border-radius: 10px;
      width: 40%;
      text-align: center;
      position: relative;
    }

    h3 {
      margin-bottom: 20px;
    }

    .service-status {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
    }

    .status-icon {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .circle {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: bold;
    }

    .loading {
      background-color: black;
      color: white;
    }

    .loading .icon {
      color: white;
      animation: spin 1s infinite linear;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .success {
      background-color: green;
      color: white;
    }

    .error {
      background-color: red;
      color: white;
    }

    .icon {
      font-size: 20px;
    }
  </style>
</div>